import React from 'react';
import { ChartKey } from './ChartKey';
import styles from '../styles.scss';

export interface StatStructure {
  color: string;
  label: string;
  count: number;
}

export interface ChartLegendProps {
  statsStructures?: StatStructure[];
}

export const ChartLegend: React.FC<ChartLegendProps> = ({ statsStructures }) => {
  if (!statsStructures) {
    return null;
  }
  return (
    <div className={styles.responses}>
      <div className={styles.optionsContainer}>
        {statsStructures.map((structure, idx) => {
          const { color, label, count } = structure;

          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`stat-${idx}`} className={styles.option}>
              <ChartKey color={color} />
              <div className={styles.label}>{label}</div>
              <div className={styles.count}>{count}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
